(() => {
  document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-ec-contact-choice]');
    if (!choice) return;

    const value = choice.getAttribute('data-ec-contact-choice');
    const select = document.getElementById('EccomiContactEcosystem');
    const toggle = document.getElementById('EccomiContactHelperToggle');
    if (!select || !value) return;

    const option = Array.from(select.options).find(
      (item) => item.value === value || item.text === value
    );

    if (option) {
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (toggle) toggle.checked = false;

    const field = select.closest('.ec-contact-form__field');
    if (field) {
      field.classList.add('is-ec-selected');
      window.setTimeout(() => field.classList.remove('is-ec-selected'), 1800);
    }

    window.setTimeout(() => {
      select.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => select.focus({ preventScroll: true }), 450);
    }, 80);
  });
})();


document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('aiutami') !== 'scegliere') return;

  const toggle = document.getElementById('EccomiContactHelperToggle');
  if (!toggle) return;

  toggle.checked = true;

  window.setTimeout(() => {
    const helper = document.querySelector('.ec-contact-helper');
    if (helper) helper.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 120);
});


document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const ecosystem = params.get('ecosistema');
  if (!ecosystem) return;

  const select = document.getElementById('EccomiContactEcosystem');
  if (!select) return;

  const wanted = ecosystem.trim().toUpperCase();
  const option = Array.from(select.options).find((item) => {
    return (item.value || item.text || '').trim().toUpperCase() === wanted;
  });

  if (!option) return;
  select.value = option.value;
  select.dispatchEvent(new Event('change', { bubbles: true }));

  const field = select.closest('.ec-contact-form__field');
  if (field) field.classList.add('is-ec-selected');
});
